import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    isShowExchange: false,
    isRecordProgress: true,
    sessionToken: null,
    user: null, // 用户信息
    myCourseIds: [], // 我的课程 ID 列表
    currentQuiz: null, // 当前题目（用于全屏答题跳转）
    quizResult: null // 答题结果（用于全屏答题返回）
  },
  mutations,
  actions,
  getters,
})
export default store
